import type { AppNotification } from './types';

function stringValue(value: unknown): string | null {
  return typeof value === 'string' && value.length > 0 ? value : null;
}

export function notificationPath(notification: AppNotification): string {
  const { type, data } = notification;
  switch (type) {
    case 'CAMPAIGN_COMPLETED':
    case 'CAMPAIGN_FAILED': {
      const campaignId = stringValue(data['campaignId']);
      return campaignId ? `/campaigns/${campaignId}` : '/campaigns';
    }
    case 'AUTOMATION_ERROR':
    case 'AUTOMATION_ENROLLMENT_SPIKE': {
      const automationId = stringValue(data['automationId']);
      return automationId ? `/automations/${automationId}` : '/automations';
    }
    case 'IMPORT_COMPLETED':
    case 'IMPORT_FAILED':
      return '/contacts';
    case 'DOMAIN_VERIFIED':
    case 'DOMAIN_FAILED':
      return '/settings/sender-domains';
    case 'PAYMENT_FAILED':
    case 'PLAN_LIMIT_APPROACHING':
      return '/settings/billing';
    case 'CONNECTOR_ERROR':
    case 'CONNECTOR_DISCONNECTED':
      return '/connectors';
    default:
      return '/dashboard';
  }
}
